"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateRiskLevels = exports.buildRiskLevels = exports.getMaskedPhoneNumber = exports.getMaskedEmailId = exports.validatePassword = exports.validateUsername = exports.validateByRules = void 0;
const constants_1 = require("../common/constants");
/**
 * Validate a string is fullfil the rules required
 * @param {string} value
 * @param {ValidationRules} rules Map of the rules required for validation
 * @returns {Array<string>} Rule name does not meet the requirement
 */
const validateByRules = (value, rules) => {
    return Object.keys(rules).reduce((issues, ruleName) => {
        const rule = rules[ruleName];
        let valid = true;
        if (typeof rule === 'function') {
            valid = rule(value);
        }
        else if (typeof rule === 'object' && typeof rule.test === 'function') {
            valid = rule.test(value);
        }
        else {
            console.warn(`Non-supported validation rule of ${ruleName}`);
        }
        if (valid)
            return issues;
        return [...issues, ruleName];
    }, []);
};
exports.validateByRules = validateByRules;
const validateUsername = (value, rules = constants_1.USERNAME_RULES) => {
    return (0, exports.validateByRules)(value, rules);
};
exports.validateUsername = validateUsername;
const validatePassword = (value, rules = constants_1.PASSWORD_RULES) => {
    return (0, exports.validateByRules)(value, rules);
};
exports.validatePassword = validatePassword;
const getMaskedEmailId = (emailId) => {
    let maskedEmailId = emailId.replace(constants_1.MASKED_EMAIL_REGEX, constants_1.ASTERISKS);
    if (maskedEmailId == emailId) {
        maskedEmailId = emailId.replace(constants_1.MASKED_EMAIL_SPECIAL_CASE_REGEX, constants_1.ASTERISKS);
    }
    return maskedEmailId;
};
exports.getMaskedEmailId = getMaskedEmailId;
const getMaskedPhoneNumber = (phoneNumber) => {
    return phoneNumber.replace(constants_1.MASKED_PHONE_REGEX, constants_1.ASTERISKS);
};
exports.getMaskedPhoneNumber = getMaskedPhoneNumber;
const buildRiskLevels = (scoreList) => {
    const sortedScoreList = [...scoreList];
    sortedScoreList.sort((a, b) => a.lowerBound - b.lowerBound);
    if (sortedScoreList[0].lowerBound > 1) {
        throw new Error('First element should start from level 1');
    }
    for (let i = 0; i < sortedScoreList.length - 1; i++) {
        if (sortedScoreList[i].upperBound !==
            sortedScoreList[i + 1].lowerBound - 1) {
            throw new Error('There is a gap in score tiers');
        }
    }
    const result = [];
    for (let i = 0; i < sortedScoreList.length; i++) {
        const levelPayLoad = {
            level: i + 1,
            lowerBound: sortedScoreList[i].lowerBound,
            upperBound: sortedScoreList[i].upperBound,
            name: sortedScoreList[i].name,
            description: sortedScoreList[i].description,
        };
        result.push(levelPayLoad);
    }
    return result;
};
exports.buildRiskLevels = buildRiskLevels;
const calculateRiskLevels = (score, riskLevels) => {
    for (const level of riskLevels) {
        if (score >= level.lowerBound && score <= level.upperBound) {
            return level;
        }
    }
    return null;
};
exports.calculateRiskLevels = calculateRiskLevels;
